"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminPlatform = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../shared/components");
/**
 * WsAiHubAdminPlatform - Platform configuration for AI Hub admin
 *
 * Placeholder component for platform-related settings.
 * This will include cloud platform configurations, integrations,
 * and infrastructure settings in future releases.
 *
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubAdminPlatform = function () {
    return (react_1.default.createElement(components_1.PlaceholderTab, { title: "Platform", description: "Platform-specific configurations and cloud integrations will be managed here.", className: "ws-ai-hub-admin-platform" }));
};
exports.WsAiHubAdminPlatform = WsAiHubAdminPlatform;
